/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 6623:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5671);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(136);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2963);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1120);
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7112);
/* harmony import */ var _utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4889);
/* harmony import */ var _utils_pricing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9299);






function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




var ConfiguratorVariant = /*#__PURE__*/function (_HTMLElement) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ConfiguratorVariant, _HTMLElement);

  var _super = _createSuper(ConfiguratorVariant);

  function ConfiguratorVariant() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, ConfiguratorVariant);

    _this = _super.call(this);

    var products = _this.querySelector('#js-products').innerHTML;

    var buttons = _this.querySelectorAll('.colors-grid__item');

    var colorGrid = _this.querySelector('.colors-grid');

    var select = _this.querySelector('.variant-select');

    var layer = _this.querySelector('.configurator-variant').dataset.layer;

    var imageLayer = _this.querySelector('.configurator-variant').dataset.imagelayer;

    var nextButton = _this.querySelector('.button-holder__button');

    var previousButton = _this.querySelector('.button-holder__button--previous');

    var buttonRow = document.querySelector('.button-row__fade');

    var pricingElement = _this.querySelector('.js-pricing');

    var param = select.getAttribute('data-select');
    console.log('variant');

    var handleFallbackImage = function handleFallbackImage() {
      var fallbackImage = document.querySelector('.configurator-media__inner').dataset.fallbackImage;
      var baseImageLayer = document.querySelector('.image-layer-1');
      baseImageLayer.removeAttribute('srcset');
      baseImageLayer.src = fallbackImage;
    };

    var setUrlParams = function setUrlParams(selectElement, variant, product) {
      console.log(selectElement, variant, product);
      var param = selectElement.getAttribute('data-select');
      var url = new URL(window.location.href);
      url.searchParams.set(param, "".concat(product.id, "-").concat(variant.id));
      window.history.replaceState({}, '', url);
    };

    var setLocalstorage = function setLocalstorage(variant) {
      var currentConfig = sessionStorage.getItem('configuratorConfig') ? JSON.parse(sessionStorage.getItem('configuratorConfig')) : [];
      currentConfig[layer] = variant;

      if (currentConfig) {
        sessionStorage.setItem('configuratorConfig', JSON.stringify(currentConfig));
      }

      if (currentConfig[1] == null) {
        handleFallbackImage();
      }
    };
    /**
     * Check for preferred size of the hoeslaken option. 
     * This will be linked to the preselected size of the bedmate
     */


    var prefSizeCheck = function prefSizeCheck(size) {
      var prefSizeArray = ['160X200X30', '180X200X30', '50X'];
      return prefSizeArray.includes(size);
    };

    var handleVariantSelect = function handleVariantSelect(product, select, discount, trigger) {
      
      var options_not_disabled = select.querySelectorAll('option:not([disabled])');
      var options = select.querySelectorAll('option');
      var availableVariants = product.variants.filter(function (variant) {
        return variant.available;
      });
      console.log('options', options, options_not_disabled);
      console.log('availableVariants', availableVariants);
     if(options_not_disabled.length > 0) {
        setLocalstorage(availableVariants.find(function (variant) {
          return variant.title.includes(options_not_disabled[0].value);
        }));
      } 
      if(options_not_disabled.length == 0) {
        setLocalstorage(null);
        select.querySelectorAll('option')[0].selected = true;
      }
      document.querySelector('.colors-grid__item[data-id="'+product.id+'"]').classList.remove("disabled");
     if(select.querySelectorAll('option[disabled]').length == options.length) {
      document.querySelector('.colors-grid__item[data-id="'+product.id+'"]').classList.add("disabled");
     }
      
      fetch(`/products/${product.handle}`)
      .then(res => res.text())
      .then(htmlString => {
        var parser = new DOMParser();
        var doc = parser.parseFromString(htmlString, "text/html"); 
        var sizeChartEl = doc.querySelector("size-chart");

        if (sizeChartEl) {
          document.querySelector('.js_sizing_table').classList.remove("hidden");
          document.querySelector('.sizechart_studiosuit').innerHTML = sizeChartEl.innerHTML;
        } else {
          document.querySelector('.js_sizing_table').classList.add("hidden");
          console.log("Size chart not found"); 
        }
      })
      .catch(err => console.error(err));


      if (trigger !== 'initial') {
        if(options_not_disabled.length == 0) {
          setUrlParams(select, product.variants.find(function (variant) {
            return variant.title.includes(options[0].value);
          }), product);

        } else {
          setUrlParams(select, availableVariants.find(function (variant) {
            return variant.title.includes(options_not_disabled[0].value);
          }), product);
        }
        
      }

      var hasUrlBasedOption = false;
      options.forEach(function (option) {
        if (option.getAttribute('data-set-by-url') === 'true') {
          hasUrlBasedOption = true;
        }
      });
      select.addEventListener('change', function (e) {
        var variant = product.variants.find(function (variant) {
          return variant.title.includes(e.target.value);
        });
        pricingElement.innerHTML =
  (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__/* .pricing */.D)(
    (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .renderDiscount */.PM)(
      variant.price,
      discount,
      (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .multipleProducts */.oX)(variant)
    )
  ) +
  ' <span class="percentage">(' + discount + '%)</span>' +
  '<s>' +
  (
    (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .multipleProducts */.oX)(variant)
      ? (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__/* .pricing */.D)(variant.price * 2)
      : (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__/* .pricing */.D)(variant.price)
  ) +
  '</s>';

        setLocalstorage(variant);
        setUrlParams(select, variant, product);

        if (variant.image) {
          (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .handleProductImage */ .Au)(variant.image, imageLayer, variant.image_url);
        }

        if (prefSizeCheck(e.target.value)) {
          sessionStorage.setItem('studiosuite_pref_size', JSON.stringify(e.target.value.split('X')[0]));
        }

           if(variant.available == false || select.querySelector(`option[value="${select.value}"]`).hasAttribute("disabled") == true) {
        select.closest('configurator-variant').querySelector('button.button-holder__button.button').classList.add("disabled");
      } else {
        select.closest('configurator-variant').querySelector('button.button-holder__button.button').classList.remove("disabled");
      }
      
        window.updateSummaryPopup();
      });

      if (product) {
        nextButton.disabled = false;
        nextButton.classList.remove('disabled');
        // nextButton.innerHTML = window.product.next_step;
      }

       if(options_not_disabled.length == 0) {
        select.closest('configurator-variant').querySelector('button.button-holder__button.button').classList.add("disabled");
      } else {
        select.closest('configurator-variant').querySelector('button.button-holder__button.button').classList.remove("disabled");
      }
      
           var view_all_check = JSON.parse(sessionStorage.getItem('configuratorConfig')) != null ? JSON.parse(sessionStorage.getItem('configuratorConfig')).every(item => item === null) : false;
          if(JSON.parse(sessionStorage.getItem('configuratorConfig')) == null || view_all_check) {
            document.querySelectorAll('.view_summary').forEach(function(view_summary){
              view_summary.style.display = 'none';
            });
          } else {
            document.querySelectorAll('.view_summary').forEach(function(view_summary){
              view_summary.style.display = 'block';
            });
          }

          var currentConfig = sessionStorage.getItem('configuratorConfig') ? JSON.parse(sessionStorage.getItem('configuratorConfig')) : [];
           if (currentConfig && currentConfig[4]) {
          console.log("ssssss");
          var extraProducts = currentConfig[4];
          var totalPrice = 0;
          Object.values(extraProducts).forEach(function(item) {
            if (item && item.product_id) {
              var price = item.price;
              totalPrice += price;
              console.log("totalPrice ", totalPrice);
            }
          });
          var discounted = totalPrice - (totalPrice * 0.2);
          var formattedDiscounted = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(discounted);
          var formattedOriginal = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(totalPrice);
          document.querySelectorAll('.js_price_extra')[document.querySelectorAll('.js_price_extra').length - 1].innerHTML =
            formattedDiscounted + "(20% off) <s>" + formattedOriginal + "</s>";
        }

          
    };

    var handleProductVariants = function handleProductVariants(product, trigger) {
      console.log(product, " == product");

      var variants = product.variants;
      var optionsArray = ['135X200','155X220','200X200', '200X220', '240X220', '260X220', '140X220', '140X200', '60X70', '65X65', '50X75', '160X200X30', '180X200X30', '200X210X30', '50X160', '50X180', '90X200X30', '40X80', '80X80', '155X200', '135X200'];
      var currentOption = document.querySelector('.button-row__button input[checked]');
      var discountbase = document.querySelector('configurator-overview').dataset.baseDiscount;
      var discountextra = document.querySelector('configurator-overview').dataset.extraDiscount;
      var discount = currentOption.dataset.layer <= 3 ? discountbase : discountextra;
      var items = 0;
      var disabled = true;
      var options = variants.map(function (variant) {
        console.log(variant.option2, "variant.option2");
        if (optionsArray.includes(variant.option2.toUpperCase())) {
          items++;
          if (variant.available) {
            disabled = false;
          }
          return "<option value=\"".concat(variant.option2, "\" data-old-price=\"").concat((0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__/* .pricing */ .D)(variant.price), "\" data-id=\"").concat(variant.id, "\" ").concat(!variant.available ? 'disabled' : null, " ").concat(variant.option2.includes('90X200X30') && variant.inventory_quantity <= 1 ? 'disabled' : null, " ").concat(variant.option2.includes('140') && variant.inventory_quantity <= 1 ? 'disabled' : null, " ").concat(variant.option2.includes('60X70') && variant.inventory_quantity <= 1 ? 'disabled' : null, " ").concat(variant.option2.includes('65X65') && variant.inventory_quantity <= 1 ? 'disabled' : null, " ").concat(variant.option2.includes('50X75') && variant.inventory_quantity <= 1 ? 'disabled' : null, ">").concat(variant.option2.includes('140') || variant.option2.toUpperCase().includes('80X80') || variant.option2.toUpperCase().includes('40X80') || variant.option2.toUpperCase().includes('60X70') || variant.option2.toUpperCase().includes('65X65') || variant.option2.toUpperCase().includes('50X75') || variant.option2.includes('90X200X30') || variant.option2.toLowerCase().includes('135x200') || variant.option2.toLowerCase().includes('155x220')? variant.option2 + ' ' +window.pieces_text  : variant.option2, "</option>");
          
        }
      });
   
      var firstAvailableVariant = variants.find(function (variant) {
        return variant.available;
      });
      console.log(firstAvailableVariant, firstAvailableVariant);
      pricingElement.innerHTML = 
  (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__/* .pricing */.D)(
    (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .renderDiscount */.PM)(
      firstAvailableVariant ? firstAvailableVariant.price: variants[0].price,
      discount,
      (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .multipleProducts */.oX)(firstAvailableVariant ? firstAvailableVariant : variants[0])
    )
  ) +
  ' <span class="percentage">(' + discount + '%)</span>' +
  '<s>' +
  (
    (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .multipleProducts */.oX)(firstAvailableVariant ? firstAvailableVariant : variants[0])
      ? (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__/* .pricing */.D)(firstAvailableVariant ? (firstAvailableVariant.price * 2 ): (variants[0].price * 2))
      : (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__/* .pricing */.D)(firstAvailableVariant ? firstAvailableVariant.price: variants[0].price)
  ) +
  '</s>';

  select.innerHTML = options.join('');

      if (items === 1) {
        select.style.backgroundImage = 'none';
      }

      var currentConfig = sessionStorage.getItem('configuratorConfig') ? JSON.parse(sessionStorage.getItem('configuratorConfig')) : [];
           if (currentConfig && currentConfig[4]) {
          console.log("ssssss");
          var extraProducts = currentConfig[4];
          var totalPrice = 0;
          Object.values(extraProducts).forEach(function(item) {
            if (item && item.product_id) {
              var price = item.price;
              totalPrice += price;
              console.log("totalPrice ", totalPrice);
            }
          });
          var discounted = totalPrice - (totalPrice * 0.2);
          var formattedDiscounted = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(discounted);
          var formattedOriginal = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(totalPrice);
          document.querySelectorAll('.js_price_extra')[document.querySelectorAll('.js_price_extra').length - 1].innerHTML =
            formattedDiscounted + "(20% off) <s>" + formattedOriginal + "</s>";
        }

      handleVariantSelect(product, select, discount, trigger);
      (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .handleProductImage */ .Au)(variants[0].image, imageLayer, variants[0].image_url);
    };

    var handleActiveButton = function handleActiveButton(button) {
      var color = button.querySelector('.color'); //disable all active buttons

      buttons.forEach(function (button) {
        button.querySelector('.color').classList.remove('current-selected');
      });

      if (color) {
        color.classList.add('current-selected');
      }
    };

    var handleColorIndicator = function handleColorIndicator(button) {
      var colorIndicator = _this.querySelector('.color-indicator__color');

      var color = button.dataset.color;

      if (color) {
        colorIndicator.innerHTML = color;
      }
    }; // const handleBackgroundColor = (button) => {
    //   const color = button.querySelector('.color-part')?.dataset.color
    //   const mediaContainer = document.querySelector('.configurator-media')
    //   mediaContainer.style.backgroundColor = color ? color : null
    // }


    var handleFallbackColor = function handleFallbackColor() {
      buttons.forEach(function (button) {
        if (button.querySelector('.color').classList.contains('current-selected')) {
          handleColorIndicator(button);
        }
      });
    };

    buttons.forEach(function (button) {
      button.addEventListener('click', function (e) {
        var productId = button.dataset.id ? button.dataset.id : null;
        var product = JSON.parse(products).find(function (p) {
          return p.id === Number(productId);
        });
        handleProductVariants(product, 'normal');
        handleActiveButton(button);
        handleColorIndicator(button);
        handleFallbackColor(e.target); // handleBackgroundColor(button)
        
        var currentConfig = sessionStorage.getItem('configuratorConfig') ? JSON.parse(sessionStorage.getItem('configuratorConfig')) : [];
           if (currentConfig && currentConfig[4]) {
          console.log("ssssss");
          var extraProducts = currentConfig[4];
          var totalPrice = 0;
          Object.values(extraProducts).forEach(function(item) {
            if (item && item.product_id) {
              var price = item.price;
              totalPrice += price;
              console.log("totalPrice ", totalPrice);
            }
          });
          var discounted = totalPrice - (totalPrice * 0.2);
          var formattedDiscounted = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(discounted);
          var formattedOriginal = (0,_utils_pricing__WEBPACK_IMPORTED_MODULE_5__.D)(totalPrice);
          document.querySelectorAll('.js_price_extra')[document.querySelectorAll('.js_price_extra').length - 1].innerHTML =
            formattedDiscounted + "(20% off) <s>" + formattedOriginal + "</s>";
        }
        window.height_scroll();
      });
      button.addEventListener('mouseenter', function () {
        handleColorIndicator(button);
      });
      button.addEventListener('mouseleave', function () {
        handleFallbackColor();
      });
    });

    var handleNextStep = function handleNextStep() {
      var buttonState = false;
      buttons.forEach(function (button) {
        if (button.checked) {
          button = true;
        }
      });
      return buttonState;
    };

    nextButton.addEventListener('click', function (e) {
      var nextLayer = nextButton.dataset.next;
      var currentLayer = nextButton.dataset.current;
      var nextStep = document.querySelector(".layer-".concat(nextLayer));
      var currentLabel = document.querySelector(".layer-label-".concat(currentLayer));
      var currentlabelwidth = document.querySelector(".layer-label-".concat(currentLayer)).offsetWidth;
      var checkmark = document.querySelector(".layer-label-".concat(currentLayer, " .icon-checkmark"));
      var overview = document.querySelector('configurator-overview');
      var newScrollPosition = currentlabelwidth + buttonRow.scrollLeft;

      if (Number(nextLayer) == 4) {
        overview.classList.remove('hidden');
        console.log("ddd"); 
         var selectedItems = JSON.parse(sessionStorage.getItem('configuratorConfig'));
         var filteredItems = selectedItems ? selectedItems.filter((selectedItem) => selectedItem !== null) : [];
 
         var selected_items = [];
 
         filteredItems.forEach(function(val){
           if (Object.entries(val)[0][1].extraProduct === true) {
             for (let i in val) {
               var v = val[i];
               if (v && v.product_title && v.option1 && v.option2) {
                 selected_items.push({
                   title: v.product_title,
                   select_colour: v.full_option1,
                   select_size: v.full_option2
                 });
               }
             }
           } else {
             selected_items.push({
               title: val.product_title,
               select_colour: val.full_option1,
               select_size: val.full_option2
             });
           }
         });
 
         window.dataLayer = window.dataLayer || [];
 
         // Check if exact same ecommerce.items already pushed
         const alreadyPushed = window.dataLayer.some(entry =>
           entry.event === 'configuratorItemsSelected' &&
           JSON.stringify(entry.ecommerce?.items) === JSON.stringify(selected_items)
         );
 
         if (!alreadyPushed) {
           window.dataLayer.push({
             event: 'configuratorItemsSelected',
             ecommerce: {
               items: selected_items
             }
           });
         }
 
      }

      if (nextStep) {
        nextStep.checked = true;
        nextStep.classList.add('active');
        nextStep.parentElement.classList.remove('button-row__button--no-events');
        checkmark.classList.add('icon-checkmark--active');
        currentLabel.classList.add('handled');
        buttonRow.scroll({
          top: 0,
          left: newScrollPosition,
          behavior: 'smooth'
        });

        if (nextStep.closest('.button-row__button.hidden') != null){
          document.querySelector('.layer-5').checked = true;
          document.querySelector('.layer-5').classList.add('active');
          document.querySelector(".layer-label-".concat(5, " .icon-checkmark")).classList.toggle('icon-checkmark--active');
        }
      }
      
    if ($(window).width() <= 768) {
        console.log("mobile");
        window.scrollTo({
          top: 132,
          left: 0,
          behavior: "smooth",
        });
    } else {
       window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
    }


    });
    previousButton === null || previousButton === void 0 ? void 0 : previousButton.addEventListener('click', function (e) {
      var nextLayer = previousButton.dataset.next;
      var currentLayer = previousButton.dataset.current;
      var nextStep = document.querySelector(".layer-".concat(nextLayer));
      var currentLabel = document.querySelector(".layer-label-".concat(currentLayer));
      var currentlabelwidth = document.querySelector(".layer-label-".concat(currentLayer)).offsetWidth;
      var checkmark = document.querySelector(".layer-label-".concat(currentLayer, " .icon-checkmark"));
      var overview = document.querySelector('configurator-overview');
      var newScrollPosition = currentlabelwidth + buttonRow.scrollRight;

      if (Number(nextLayer) == 4) {
        overview.classList.remove('hidden');

        var selectedItems = JSON.parse(sessionStorage.getItem('configuratorConfig'));
        var filteredItems = selectedItems ? selectedItems.filter((selectedItem) => selectedItem !== null) : [];

        var selected_items = [];

        filteredItems.forEach(function(val){
          if (Object.entries(val)[0][1].extraProduct === true) {
            for (let i in val) {
              var v = val[i];
              if (v && v.product_title && v.option1 && v.option2) {
                selected_items.push({
                  title: v.product_title,
                  select_colour: v.full_option1,
                  select_size: v.full_option2
                });
              }
            }
          } else {
            selected_items.push({
              title: val.product_title,
              select_colour: val.full_option1,
              select_size: val.full_option2
            });
          }
        });

        window.dataLayer = window.dataLayer || [];

        // Check if exact same ecommerce.items already pushed
        const alreadyPushed = window.dataLayer.some(entry =>
          entry.event === 'configuratorItemsSelected' &&
          JSON.stringify(entry.ecommerce?.items) === JSON.stringify(selected_items)
        );

        if (!alreadyPushed) {
          window.dataLayer.push({
            event: 'configuratorItemsSelected',
            ecommerce: {
              items: selected_items
            }
          });
        }

      }

      if (nextStep) {
        nextStep.checked = true;
        nextStep.classList.remove('active');
        nextStep.parentElement.classList.remove('button-row__button--no-events');
        checkmark.classList.remove('icon-checkmark--active');
        currentLabel.classList.remove('handled');
        buttonRow.scroll({
          top: 0,
          left: newScrollPosition,
          behavior: 'smooth'
        });

        if (nextStep.closest('.button-row__button.hidden') != null){
          document.querySelector('.layer-5').checked = true;
          document.querySelector('.layer-5').classList.add('active');
          document.querySelector(".layer-label-".concat(5, " .icon-checkmark")).classList.toggle('icon-checkmark--active');
        }
      }
    });

    if (colorGrid) {
      (0,_utils_configurator_utils__WEBPACK_IMPORTED_MODULE_2__/* .handleColorScroll */ .au)(colorGrid);
    }

    var handleActiveURLParams = function handleActiveURLParams(trigger) {
      var url = new URL(window.location.href);
      url.searchParams.forEach(function (value, key) {
        if (param === key) {
          var productId = value.split('-')[0];
          var variantId = value.split('-')[1];
          var product = JSON.parse(products).find(function (p) {
            return p.id === Number(productId);
          });
          var variant = product === null || product === void 0 ? void 0 : product.variants.find(function (v) {
            return v.id === Number(variantId);
          });
          handleProductVariants(product, trigger);

          var activeProduct = _this.querySelector(".colors-grid__item[data-id=\"".concat(productId, "\"]"));

          var color = activeProduct.querySelector('.color');
          color === null || color === void 0 ? void 0 : color.classList.add('current-selected');

          var _select = _this.querySelector('.variant-select');

          var options = _select.querySelectorAll('option');

          setTimeout(function () {
            options.forEach(function (option) {
              if (option.value.includes(variant.option2)) {
                option.selected = true;
                option.setAttribute('data-set-by-url', true);
                _select.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }); 
          }, 750);
        }
      });
    }; // // onload url params
    // window.addEventListener('load', () => {
    //   handleActiveURLParams('initial')
    // })


    setTimeout(function () {
      handleActiveURLParams('initial');
    }, 50);
    return _this;
  }

  return ConfiguratorVariant;
}( /*#__PURE__*/(0,_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(HTMLElement));

if (customElements.get('configurator-variant') === undefined) {
  customElements.define('configurator-variant', ConfiguratorVariant);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	!function() {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = function(result, chunkIds, fn, priority) {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var chunkIds = deferred[i][0];
/******/ 				var fn = deferred[i][1];
/******/ 				var priority = deferred[i][2];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every(function(key) { return __webpack_require__.O[key](chunkIds[j]); })) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/runtimeId */
/******/ 	!function() {
/******/ 		__webpack_require__.j = 952;
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			952: 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = function(chunkId) { return installedChunks[chunkId] === 0; };
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkIds[i]] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkworkflow"] = self["webpackChunkworkflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, [1216], function() { return __webpack_require__(6623); })
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
; 